import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const botMessage = createAction(types.BOT_MESSAGE, (botMessage: string) => ({
    payload: botMessage,
}));
